'use strict';
const CONTROLLER__AJAX = 'ajax';

const buildUrl = (params, pluginName) => {
  var data = '?type='.concat(
    params.typeNum,
    '&id=',
    $('html').attr('data-page-id'),
    '&L=',
    params.languageUid
  );

  var extension = params.extension;
  delete params.extension;
  delete params.typeNum;
  delete params.languageUid;

  for (var index in params) {
    data = data.concat('&' + extension + '_' + pluginName, '[', index, ']=', params[index]);
  }

  return data;
};

/**
 * Params example:
 * ---
 * var params = {
 *		action: 'showMore',
 *		controller: 'Ajax,
 *		extension: 'vdthemevalid',
 *		typeNum: 85790
 * };
 */

const call = (params, caller, beforeSend, success) => {
  handler(params, caller, beforeSend, success);
};

const handler = (params, caller, beforeSend, success) => {
  let dataType = 'json';
  if (params.hasOwnProperty('dataType')) {
    dataType = params.dataType;
    delete params.dataType;
  }

  let plugin = 'pi1';
  if (typeof params.plugin !== 'undefined') {
    plugin = params.plugin;
    delete params.plugin;
  }

  let url = buildUrl(params, plugin);

  $.ajax({
    async: 'true',
    url: url,
    type: 'POST',
    dataType: dataType,
    data: {},
    beforeSend: function() {
      execute__beforeSend(params, caller, beforeSend);
    },
    success: function(data) {
      execute__onSuccess(params, caller, data, success);
    },
    error: function(xhr, e) {
      var message = handleErrorMessage(xhr, e);
      switch (params['action']) {
        default:
      }
    },
  });
};

const execute__beforeSend = (params, caller, beforeSend) => {
  switch (params.action) {
    default:
  }

  if (typeof beforeSend === 'function') {
    beforeSend(params, caller);
  }
};

const execute__onSuccess = (params, caller, data, success) => {
  switch (params.action) {
    default:
  }

  if (typeof success === 'function') {
    success(params, caller, data);
  }
};

const handleErrorMessage = (xhr, e) => {
  var message = '';
  if (xhr.status == 0) {
    message = 'You are offline!!\n Please Check Your Network.';
  } else if (xhr.status == 404) {
    message = 'Requested URL not found.\n' + xhr.responseText;
  } else if (xhr.status == 500) {
    message = 'Internel Server Error.\n' + xhr.responseText;
  } else if (e == 'parsererror') {
    message = 'Parsing JSON Request failed.\n' + xhr.responseText;
  } else if (e == 'timeout') {
    message = 'Request Time out.';
  } else {
    message = 'Unknown Error.\n' + xhr.responseText;
  }
  return message;
};

export { buildUrl, call, handleErrorMessage, execute__beforeSend, execute__onSuccess };
